import { render, staticRenderFns } from "./CbsPivotInput.vue?vue&type=template&id=6336bd3a&scoped=true"
import script from "./CbsPivotInput.vue?vue&type=script&lang=js"
export * from "./CbsPivotInput.vue?vue&type=script&lang=js"
import style0 from "./CbsPivotInput.vue?vue&type=style&index=0&id=6336bd3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336bd3a",
  null
  
)

export default component.exports